/**
 *
 * ProgressIcon for BulkActionQueuedItem
 *
 */

import { Loader } from '@fountain/fountain-ui-components';
import {
  CheckCircleOutlineIcon,
  ExclamationOutlineIcon,
  Icon,
} from '@fountain/ripple/icon';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { useIntl } from 'react-intl';

import { BULK_ACTION_STATUS } from 'containers/BulkActionQueue/constants';
import NoProgressIcon from 'images/no-progress.svg';

import messages from './messages';
import useStyles from './styles';

const ProgressIcon = ({ progress, status, isLoading }) => {
  const classes = useStyles();
  const theme = useTheme();
  const intl = useIntl();

  if (status === BULK_ACTION_STATUS.complete)
    return (
      <Icon
        icon={CheckCircleOutlineIcon}
        size="sm"
        color="green"
        role="img"
        aria-hidden={false}
        aria-label={intl.formatMessage(messages.complete)}
      />
    );
  if (
    status === BULK_ACTION_STATUS.running ||
    status === BULK_ACTION_STATUS.pending
  )
    return (
      <CircularProgressbar
        className={classes.circularProgressbar}
        value={progress}
        strokeWidth={10}
        styles={buildStyles({
          pathColor: theme.palette.common.blue400,
          trailColor: theme.palette.common.gray200,
        })}
      />
    );
  if (status === BULK_ACTION_STATUS.errored) {
    return (
      <Icon
        icon={ExclamationOutlineIcon}
        size="sm"
        color="rose"
        role="img"
        aria-hidden={false}
        aria-label={intl.formatMessage(messages.errored)}
      />
    );
  }
  if (isLoading) {
    return <Loader size="1rem" />;
  }
  return <img src={NoProgressIcon} alt="no-progress-icon" />;
};

ProgressIcon.propTypes = {
  progress: PropTypes.number,
  status: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

export default ProgressIcon;
